class optionalItems extends HTMLElement {
  constructor() {
    super();
    this.variantChangeUnsubscriber = undefined;
  }

  connectedCallback() {

    // Subscribe to variant changes
    this.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.handleVariantChange.bind(this)
    );
    this.updateMainItemPrices()
    this.syncSelectedOptionalVariantWithMainVariant();
  }

  disconnectedCallback() {
    this.variantChangeUnsubscriber?.();
  }

  handleVariantChange({ data }) {
    // data contains: { sectionId, html, variant }
    console.log('Variant changed:', data.variant.id);
    const mainProduct = this.querySelector('[data-current-product]');
    mainProduct.querySelector('input[name="configure-backpack"]').value = data.variant.id;

    // Update your fields here
    this.updateMainItemPrices();
    this.syncSelectedOptionalVariantWithMainVariant();
  }

  syncSelectedOptionalVariantWithMainVariant() {
    const OptionalItems = this.querySelectorAll('input[type="radio"][name="configure-backpack"]');
    if (!OptionalItems.length) return;

    const mainSelected = document.querySelector('variant-selects input:checked');
    if (!mainSelected ) return;

    OptionalItems.forEach((optionalItem) => {
      const item = optionalItem.closest('.product-list__item');
      const bundleVariants = item?.querySelector('[data-bundle-variants-connected]');
      if (!bundleVariants) return;

      const linkedVariant = bundleVariants.querySelector(`input[name="${mainSelected.value}"]`);
      if (!linkedVariant) return;

      optionalItem.value = linkedVariant.value;
      const priceNode = item.querySelector('.price .pdp-sale-price');
      const priceOriginal = item.querySelector('.price .pdp-regular-price');

      if (priceNode && linkedVariant.dataset.price) {
        priceNode.textContent = linkedVariant.dataset.price;
      }
      if (priceOriginal && linkedVariant.dataset.originalPrice) {
        priceOriginal.textContent = linkedVariant.dataset.originalPrice;
      }
      // update the value of the input
      OptionalItems.value = linkedVariant.value;
    });
  }

  updateMainItemPrices() {
    const mainProduct = this.querySelector('[data-current-product]');
    if (!mainProduct) return;

    const mainPriceWrapper = document.querySelector('.price-wrapper');
    if (!mainPriceWrapper) return;

    const priceNode = mainProduct.querySelector('.price .pdp-sale-price');
    const priceOriginal = mainProduct.querySelector('.price .pdp-regular-price');

    if (priceNode && mainPriceWrapper.querySelector('.pdp-sale-price')) {
      priceNode.textContent = mainPriceWrapper.querySelector('.pdp-sale-price').dataset.salePrice;
    }
    if (priceOriginal && mainPriceWrapper.querySelector('.pdp-regular-price')) {
      priceOriginal.textContent = mainPriceWrapper.querySelector('.pdp-regular-price').dataset.regularPrice;
    }

  }
}

customElements.define('optional-items', optionalItems);